import { useState } from "react";
import { Tooltip, Grid, FormControl, Select, MenuItem, InputLabel } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import UploadInput from "../../../global/UploadInput";
import useCatalogos from "../../../hooks/useCatalogos";
import { getBase64 } from "../../../utils/fileBase64";
import BackDrop from "../../../global/BackDrop";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { actualizaTipoExtraTerrestreAction, obtenerExtrasPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";

const FTipoExtra = (props) => {
    const { idExtra, Nombre } = props
     const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)

    const dispatch = useDispatch()
    const catTipoExtra = useCatalogos("Extras");
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState([]);
    const [tipoExtra, setTipoExtra] = useState(0);
    const [load, setLoad] = useState(false)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelecTipoExtra = (event) => {
        setTipoExtra(event.target.value);
    };
    const onGuardar = () => {
        if (file.length > 0) {
            setLoad(true);
            file.forEach(async (archivo) => {
                await getBase64(archivo).then((result) => {
                    const Logobase64 = String(result).split(",")[1];

                    console.log("TIPO EXTRA", tipoExtra);
                    
                    let payload = {
                        idExtra: idExtra,
                        idCatExtra: tipoExtra,
                        imagen: Logobase64,
                        extencion:
                            archivo.name.split(".")[archivo.name.split(".").length - 1],
                    };
                    dispatch(actualizaTipoExtraTerrestreAction(payload)).then((Response) => {
                        setLoad(false);
                        if (Response.status && Response.status === 500) {
                            ToastMessage.fire({
                                icon: "error",
                                title: "Ha habido un problema con el servidor",
                            });
                            return null
                        }
                        dispatch(obtenerExtrasPaqueteTerrestre({idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre}))
                        LimpiarForm();
                        ToastMessage.fire({
                            icon: "success",
                            title: "Ingreso Correcto",
                        });
                    });
                });
            });
        } else {
            ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Seleccione por lo menos una imagen.",
            });
        }
    };
    const LimpiarForm = () => {
        setTipoExtra(0);
        setFile([]);
        setLoad(false)
        setOpen(false)
    };
    return (
        <div>
            <Tooltip title="Asginar tipo extra">
                <span>
                    <Button
                        variant="text"
                        color="primary"
                        onClick={handleClickOpen}
                    >
                        <PlaylistAddIcon />
                    </Button>
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-Extra"
                maxWidth="md"
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-Extra">Asignar tipo extra a {Nombre}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FormControl variant="outlined" style={{ margin: "20px 10px", width: "40%" }}>
                                    <InputLabel id="lTipoExtra">Tipo Extra</InputLabel>
                                    <Select
                                        labelId="lTipoExtra"
                                        id="STipoExtra"
                                        name="tipoImagen"
                                        value={tipoExtra}
                                        onChange={handleSelecTipoExtra}
                                        label="Tipo Extra"
                                    >
                                        <MenuItem value="0" disabled>
                                            {"Seleccione una opción"}
                                        </MenuItem>
                                        {catTipoExtra.map((item, index) => (
                                            <MenuItem
                                                key={item.idCatExtra}
                                                value={item.idCatExtra}
                                            >
                                                {`${item.Descripcion}`}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {tipoExtra > 0 && (
                                <UploadInput
                                    files={file}
                                    setFiles={setFile}
                                    multiple={false}
                                />
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Button onClick={onGuardar} color="primary" variant="contained">
                        Aplicar
                    </Button>
                </DialogActions>
            </Dialog>
            <BackDrop open={load} />
        </div>
    )
}
export default FTipoExtra